import React, { useState } from "react";
import styled from "styled-components";

import ProgressBar from "./ProgressBar";

const Form = styled.form`
  margin: 3rem auto 1rem;
  text-align: center;

  label input {
    height: 0;
    width: 0;
    opacity: 0;
  }
  label {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    border: 1px solid var(--primary);
    border-radius: 50%;
    margin: 1rem auto;
    line-height: 3rem;
    color: var(--primary);
    font-weight: bold;
    font-size: 2.4rem;
    span {
    }
  }
  label:hover {
    background: var(--primary);
    color: white;
  }
`;

const Output = styled.div`
  height: 6rem;
  font-size: 1.2rem;
`;

const ErrorMessage = styled.div`
  color: var(--error);
`;

const UploadForm = () => {
  const [file, setFile] = useState(null); // state przechowuje zdjęcie zaimportowane w changeHandler
  const [error, setError] = useState(null); // state przechowuje komunikat błędu

  const allowedTypes = ["image/png", "image/jpeg"];

  //! zapisuje wybrane zdjęcie w state (file)
  const changeHandler = (event) => {
    let selected = event.target.files[0]; // zapisz PIERWSZY plik z event

    // jezeli selected = true && allowedTypes zawiera selected.type -> zaktualizuj state
    if (selected && allowedTypes.includes(selected.type)) {
      setFile(selected); // zapisz zdjecie w state
      setError(null); // resetuj error
    } else {
      setFile(null); // jezeli watunki nie zostaną spełnione resetuj state zeby nie zasmiecać niepotrzebnie
      setError("Please select an image file (png or jpeg)"); // ustaw komunikat błędu
    }
  };

  //! file przekazuje do <ProgresBar/> który uzywa hooka useStorage do wysłania pliku
  return (
    <Form>
      <label>
        <input type="file" onChange={changeHandler} />
        <span>+</span>
      </label>
      <Output>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        {file && <div>{file.name}</div>}
        {file && (
          <ProgressBar
            file={file} //wyświetla progress bar gdy plik jest wybrany + przekaz plik w props
            setFile={setFile} // przekaz funkcje setFile zeby wyzerowac state po przesłaniu
          />
        )}
      </Output>
    </Form>
  );
};

export default UploadForm;
